export class AddressAutoCompleteFilter {
    public Query: string;
}

export default AddressAutoCompleteFilter;